<div class="sider-warp">
  <div class="logo">
    <img src="../../../../assets/logo.png" width="204" alt="" />
  </div>
  <div class="logo-mini">
    <img src="../../../../assets/logo-mini.png" width="40" alt="" />
  </div>
  <div class="side-line"></div>
  <ul nz-menu nzMode="inline">
    <li nz-menu-item routerLinkActive="current" routerLink="/admin/dashboard">
      <span class="icon" nz-icon nzType="desktop"></span>
      <span>仪表盘</span>
    </li>
    <li nz-menu-item routerLinkActive="current" routerLink="/admin/upload/list">
      <span class="icon" nz-icon nzType="cloud-upload" nzTheme="outline"></span>
      <span>上传列表</span>
    </li>
    <li nz-menu-item routerLinkActive="current" routerLink="/admin/workbench">
      <span class="icon" nz-icon nzType="unordered-list" nzTheme="outline"></span>
      <span>诊断列表</span>
    </li>
    <li nz-menu-item routerLinkActive="current" routerLink="/admin/setting/diagnosis">
      <span class="icon" nz-icon nzType="user" nzTheme="outline"></span>
      <span>模版管理</span>
    </li>
  </ul>
</div>
